import {Role, User} from '../../../../incase-domain/user';

const ROLES_TO_CHECK = [Role.SUPERUSER, Role.ADMIN];

export function canEditUsers(user?: User): boolean {
    return ROLES_TO_CHECK.some((role) => user?.roles.includes(role));
}

export function isUserSuperUser(user?: User): boolean {
    return !!user?.roles.includes(Role.SUPERUSER);
}
